export default {
  getList: {
    method: 'post',
    url: '/client/partner/commodity/cooperatorId/list'
  },
  getDetail: {
    method: 'get',
    url: '/client/partner/commodity/cooperatorId/detail/ID'
  },
  create: {
    method: 'post',
    url: '/client/partner/commodity/cooperatorId/create'
  },
  update: {
    method: 'put',
    url: '/client/partner/commodity/cooperatorId/update/ID'
  },
  delete: {
    method: 'delete',
    url: '/client/partner/commodity/cooperatorId/delete/ID'
  },
  archive: {
    method: 'delete',
    url: '/client/partner/commodity/archive'
  },
  restore: {
    method: 'put',
    url: '/client/partner/commodity/restore'
  }
}
